<div
  class="w-full h-full min-h-[24.375rem] flex flex-col gap-[0.75rem]">
  @let deployment = loggerDeployment();
  @let isChartFullscreenActive = isChartFullscreen();
  @let chartDataAvailable = isChartDataExist();
  @let requestError = error();

  @if (deployment) {
    <div class="flex flex-col gap-0 h-full"
      [class.sm:mb-(--date-selection-reserved-height-for-sm-and-md)]="!isChartFullscreenActive"
      [class.lg:mb-0]="!isChartFullscreenActive">

      <div class="w-full px-[0.75rem] sm:px-[1rem] pb-[0.75rem] flex items-center justify-between">
        <div class="flex items-center gap-1 flex-wrap">
          <gc-floating-popup-content-export-csv-actions
            [isDisabled]="!chartDataAvailable || !!requestError"
            (export)="doExport()">
          </gc-floating-popup-content-export-csv-actions>

          @if (!isChartFullscreenActive) {
            <gc-fp-open-custom-correlation-action></gc-fp-open-custom-correlation-action>
          }
        </div>

        @let currentPopup = popup();
        @if (currentPopup) {
          <gc-floating-popup-content-chart-actions
            class="self-end"
            [isChartFullscreen]="isChartFullscreenActive"
            (chartFullscreen)="toggleChartFullscreen()">
          </gc-floating-popup-content-chart-actions>
        }
      </div>

      @if (chartDataAvailable) {
        <div class="grow-1 min-h-0 flex flex-col px-[0.75rem] sm:px-[1rem]">
          @let chartCombinedData = combinedChartData();
          <gc-floating-popup-bar-chart-wrapper
            class="grow-1 h-full"
            [chartOptions]="chartCombinedData.chartOptions"
            [chartData]="chartCombinedData.chartData"
            [additionalPlugins]="chartPlugins">
          </gc-floating-popup-bar-chart-wrapper>
        </div>
      } @else {
        <div class="grow-1 items-center justify-center min-h-[6.25rem] flex flex-col px-[0.75rem] sm:px-[1rem]">
          <gc-floating-popup-base-error-message [requestError]="requestError"></gc-floating-popup-base-error-message>
        </div>
      }
    </div>
  }
</div>
